<template>
  <div class="card-video">

    <span class="card-video__image">
      <Image :data="image" v-if="image"/>

      <span class="card-video__play">
        <Icon name="24/play"/>
      </span>
    </span>

    <span class="card-video__title h5" v-if="title">
      {{ title }}
    </span>
  </div>
</template>

<script>
import Image from '@/components/Image/Image.vue';
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'CardVideo',
  components: { Icon, Image },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      return this.data.image;
    },
    title() {
      return this.data.title;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "CardVideo";
</style>
